import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";

function sleep(delay = 0) {
  return new Promise((resolve) => {
    setTimeout(resolve, delay);
  });
}

export default function CustomAsynchronous({
  width,
  options,
  value,
  onChange,
  dispatchAction,
  label,
  error,
  helperText,
  disabled
}) {
  const [open, setOpen] = React.useState(false);
  const [selectOptions, setSelectOptions] = React.useState([]);
  const loading = open && selectOptions.length === 0;

  React.useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    if (options?.length === 0) {
      dispatchAction && dispatchAction()
    }

    (async () => {
     
     options?.length < 1 && await sleep(1e3); // For demo purposes.

      if (active) {
        setSelectOptions([...options]);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading, options, dispatchAction]);

  React.useEffect(() => {
    if (!open) {
      setSelectOptions([]);
    }
  }, [open]);

  return (
    <Autocomplete
      id="asynchronous-demo"
      sx={{ width: width }}
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      isOptionEqualToValue={(option, value) => option.title === value.title}
      getOptionLabel={(option) => option.title}
      options={selectOptions}
      loading={loading}
      value={value}
      readOnly={disabled}
      onChange={(event, newValue) => {
        if (newValue) {
          onChange(newValue);
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          size="small"
          label={label}
          InputProps={{
            ...params.InputProps,
            endAdornment: !disabled ? (
              <React.Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ) : (
              ""
            ),
          }}
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
}
